import React, { useEffect, useState } from "react";
import request, { gql } from "graphql-request";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { BsFillPersonBadgeFill, BsFillPersonVcardFill } from "react-icons/bs";
import Grid from "@mui/material/Grid2";

import { useAuth } from "../../../context/AuthContext/AuthContextProvider";
import { useLoading } from "../../../context/LodingContext";
import { useError } from "../../../context/ErrorContext";
import { useSuccess } from "../../../context/SucccessContext";
import { useLocation, useNavigate } from "react-router-dom";
import { fromGlobalId } from "../../../lib/decoded/rawPk";
import BASEURL from "../../Utils/Baseurl";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Autocomplete,
  ButtonGroup,
  Card,
  CardContent,
  CardHeader,
  Chip,
  FormControl,
  FormHelperText,
  Stack,
  TextField,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import MaterialSelect from "../../../components/MasterSelect";
import { appointmentWithDataOptions } from "../../appointment/appointmentData";
import {
  allContact,
  allCustomer,
  allLeadprospect,
  allVendor,
  getAllTask,
  getContactdetailByMaster,
  getContactdetailByUser,
  getCustomerByMaster,
  getCustomerByUser,
  getLeadProspectByMaster,
  getLeadProspectByUser,
  getVendorByMaster,
  getVendorByUser,
  getvisitdetails,
} from "../callQuery";
import {
  addVisitService,
  updateAppointmentService,
  updateVisitService,
} from "../callMutation";
import { VisitWithDataOptions } from "./visitData";

const allUsersDetail = gql`
  query {
    allUsersDetail {
      id
      username
    }
  }
`;
const today = new Date().toISOString().split("T")[0];
// const today = new Date();
// const oneWeekAgo = new Date();
// oneWeekAgo.setDate(today.getDate() - 7);

// const formattedToday = today.toISOString().split("T")[0];
// const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];
const AppointmentForm = () => {
  const [withData, setWithData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [isOtherUserType, setIsOtherUserType] = useState(false);
  const [inputDisbledOthers, setInputDisbledOthers] = useState(true);
  const [inputDisbled, setInputDisbled] = useState(true);
  const [appointmentWithName, setAppointmentWithName] = useState("");
  const [appotimentSelctStatus, setAppotimentSelctStatus] = useState(false);
  const [employeeData, setEmployeeData] = useState([]);
  const [ titleOptions, setTitleOptions ] = useState();
  const [appoinment, setAppoinment] = useState([]);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } =
    useError();
  const [pendingLoading, setPendingLoading] = useState(false);
  const [selectCustomerOption, setSelectCustomerOption] = useState([]);
  const [contactPersonDisbledStatus, setContactDisbledPersonStatus] =
    useState(false);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
    done: "",
    back: "",
  });

  const [selectedEmployee, setSelctedEmploye] = useState([]);
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const { currentUser } = useAuth();
  const { id: rawPk } = fromGlobalId(currentUser?.id);
  const navigate = useNavigate();
  const isUser = currentUser?.role;
  const params = useLocation();
  const id = params.search.slice(1);
  const leadName = "Prospect";
  const vendor = "Vendor";
  const customer = "Customer";
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };
  const [appointmentData, setAppointmentData] = useState({
    // appointmentData
    visiteddate: today,
    time: "",
    visitedwith: "",
    withName: "",
    contactPerson: "",
    name: "",
    email: "",
    phoneNumber: "",
    description: "",

    // appointmentData status
    visiteddateStatus: "unchecked",
    timeStatus: "unchecked",
    visitedwithStatus: "unchecked",
    withNameStatus: "unchecked",
    contactPersonStatus: "unchecked",
    nameStatus: "unchecked",
    emailStatus: "unchecked",
    phoneNumberStatus: "unchecked",
    descriptionStatus: "unchecked",
  });
  const [inputData, setInputData] = useState({
    contactPerson: "",
    organizationName: "",
    contactPersonStatus: "unchecked",
    organizationNameStatus: "unchecked",
  });

  const [ taskData, setTaskData ] = useState({
      taskTitle: "",
      taskTitleStatus: "unchecked"
  });

  useEffect(() => {
    let prevState = { ...appointmentData };

    prevState.visiteddateStatus = "success";
    setAppointmentData(prevState);
  }, []);



  useEffect(() => {
    setTogglePage({
      ...togglePage,
      view: params?.search !== "" ? true : false,
    });
  }, []);

  useEffect(() => {
    request(BASEURL, allUsersDetail).then((res) =>
      setEmployeeData(res.allUsersDetail)
    );
  }, []);

  useEffect(() => {
    fetchAllTask();
  },[]);

  useEffect(() => {
    if (id) {
      fetcUpdateValue();
    }
  }, [id]);

  useEffect(() => {
    if (inputDisbledOthers) {
      setAppointmentData((prevData) => ({
        ...prevData,
        withName: "",
      }));
    } else if (!inputDisbledOthers) {
      setAppointmentData((prevData) => ({
        ...prevData,

        withName: "",
        withNameStatus: "unchecked",
      }));
    }
  }, [inputDisbledOthers]);

  //Fetch Task Title
  const fetchAllTask = async() => {
    try{
      const response = await request(BASEURL, getAllTask);
      const data = response?.allTasks?.data;
      const options = data?.map((task) => ({
        label: task.title,
        value: task.id,
      }));
      setTitleOptions(options);
      
    }
    catch(error){
      console.error("Error Fetching Data", error);
    }
  }

  //Fetch Data by ID
  const fetcUpdateValue = async () => {
    try {
      const res = await request(BASEURL, getvisitdetails, {
        id: id,
      });

      const v = res.getVisitById;
      setSelectedData(v);
      if (v.visitedwith == "Others") {
        setIsOtherUserType(true);
        setInputData({
          organizationName: v.withName,
          contactPerson: v.contactPerson,
          organizationNameStatus: "success",
          contactPersonStatus: "success",
        });
        setTaskData({
          taskTitle: {
            value: v.task.id,
            label: v.task.title,
          },
          taskTitleStatus: v.task.id ? "success" : "unchecked"
        })
      } else {
        setIsOtherUserType(false);
        
      }
      if (v.id == id) {
        setAppointmentData({
          visiteddate: v.visiteddate,
          time: v.time,
          visitedwith: {
            value: v.visitedwith,
            label: v.visitedwith,
          },
          withName: {
            value: v.withName,
            label: v.withName,
          },
          contactPerson: {
            value: v.contactPerson,
            label: v.contactPerson,
          },
          name: v.name,
          email: v.email,
          phoneNumber: v.phoneNumber,
          description: v.description,

          visiteddateStatus: "success",
          timeStatus: "success",
          visitedwithStatus: "success",
          withNameStatus: "success",
          contactPersonStatus: "success",
          nameStatus: "success",
          emailStatus: "success",
          phoneNumberStatus: "success",
          descriptionStatus: "success",
        });
        setTaskData({
          taskTitle: {
            value: v.task.id,
            label: v.task.title,
          },
          taskTitleStatus: v.task.id ? "success" : "unchecked"
        })
        const temp = [];
        v.visitappoinmentSet?.map((i) => {
          temp?.push(i.visitedPerson);
        });

        setSelctedEmploye(temp);
      }
    } catch (err) {}
  };

  //Create Mutation
  const handleAddVisit = () => {
  
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to submit your details.",
        showCancel: true,
        showConfirm: true,
  
        onConfirm: async () => {
          setCirleLoading(true);
          const visitedbydetails = selectedEmployee.map((v, i) => {
            return { visitedby: v?.id };
          });
  
          const values = {
            user: rawPk,
            visiteddate: appointmentData.visiteddate,
            time: appointmentData.time,
            visitedwith: appointmentData.visitedwith?.label,
            withName:
              appointmentWithName == "others"
                ? inputData.organizationName
                : appointmentData.withName?.label,
            //withName: appointmentData.withName?.label,
            contactPerson:
              appointmentWithName == "others"
                ? inputData.contactPerson
                : appointmentData.contactPerson?.label,
            //contactPerson: appointmentData.contactPerson?.label,
            name: appointmentData.name || "",
            email: appointmentData.email,
            phoneNumber: appointmentData.phoneNumber,
            description: appointmentData.description,
            visitedbydetails: visitedbydetails,
            taskId: taskData.taskTitle?.value,
          };
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
          const { createStatus, errormessage } = await addVisitService(values);
          setCirleLoading(false);
  
          if (createStatus) {
            setSuccessStatus(true);
  
            setSucessTitle("Visit Log Added");
            setTimeout(() => {
              setSuccessStatus(false);
              navigate("/visitdetails");
            }, 1000);
          } else {
            setErrorStatus(true);
            setErrormessage(errormessage);
            setTimeout(() => {
              setErrorStatus(false);
            }, 3000);
          }
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };

  //Update Mutation
  const handleupdateVisit = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Edit your details.",
      showCancel: true,
      showConfirm: true,

      onConfirm: async () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const values = {
          visiteddate: appointmentData.visiteddate,
          time: appointmentData.time,
          visitedwith: appointmentData.visitedwith?.label,
          withName:
            appointmentWithName == "others"
              ? inputData.organizationName
              : appointmentData.withName?.label,
          contactPerson:
            appointmentWithName == "others"
              ? inputData.contactPerson
              : appointmentData.contactPerson?.label,
          name: appointmentData.name,
          email: appointmentData.email,
          phoneNumber: appointmentData.phoneNumber,
          description: appointmentData.description,
          taskId: taskData.taskTitle?.value,
          visitedbydetails: selectedEmployee.map((v) => {
            return { visitedby: v?.id };
          }),
        };

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        setCirleLoading(true);
        const { updateStatus, errormessage } = await updateVisitService(
          values,
          id
        );
        setCirleLoading(false);
        if (updateStatus) {
          setSuccessStatus(true);
          setSucessTitle("Visit Log Updated");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/visitdetails");
          }, 1000);
        } else {
          setErrorStatus(true);
          setErrormessage(errormessage);
          setTimeout(() => {
            setErrorStatus(false);
          }, 3000);
        }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Submit Validation
  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      appointmentData.visiteddateStatus === "success" &&
      appointmentData.timeStatus === "success" &&
      appointmentData.visitedwithStatus === "success" &&
      (appointmentData.withNameStatus === "success" || inputDisbledOthers) &&
      (appointmentData.contactPersonStatus === "success" ||
        inputDisbledOthers) &&
      appointmentData.emailStatus === "success" &&
      appointmentData.phoneNumberStatus === "success" &&
      appointmentData.descriptionStatus === "success" &&
      selectedEmployee.length > 0
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  //Cancel Function
  const handleCancelVisitData = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message:
        "The Entered Details will not be saved. Do you want to Cancel it?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        // const delteStatus = await deleteBrandService(id);
        // if (delteStatus) {
        navigate("/visitdetails");
        // } else if (!delteStatus) {
        // }
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Discard Function
  const handleDiscardButton = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    if (selectedData.withName == "others") {
      setIsOtherUserType(false);
    } else {
      setIsOtherUserType(true);
      setInputData({
        organizationName: selectedData.withName,
        contactPerson: selectedData.contactPerson,
        organizationNameStatus: "success",
        contactPersonStatus: "success",
      });
    }
    setAppointmentData({
      visiteddate: selectedData.visiteddate,
      time: selectedData.time,
      visitedwith: {
        value: selectedData.visitedwith,
        label: selectedData.visitedwith,
      },
      withName: {
        value: selectedData.withName,
        label: selectedData.withName,
      },
      contactPerson: {
        value: selectedData.contactPerson,
        label: selectedData.contactPerson,
      },
      name: selectedData.name,
      email: selectedData.email,
      phoneNumber: selectedData.phoneNumber,
      description: selectedData.description,

      // appointmentData status
      visiteddateStatus: "success",
      timeStatus: "success",
      visitedwithStatus: "success",
      withNameStatus: "success",
      contactPersonStatus: "success",
      nameStatus: "success",
      emailStatus: "success",
      phoneNumberStatus: "success",
      descriptionStatus: "success",
    });
  };

  //Handle Change
  const handleAppointmentData = async (event, selectEvent) => {
    let appointmentState = { ...appointmentData };
    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "visitedwith":
          {
            const appoinmentWithValue = event?.label.toLowerCase();
            if (appoinmentWithValue == "others") {
              setIsOtherUserType(true);
              appointmentState["organizationName"] = "";
              appointmentState["organizationNameStatus"] = "unchecked";
              appointmentState["contactPerson"] = "";
              appointmentState["contactPersonStatus"] = "unchecked";
              setInputData({
                organizationName: "",
                contactPerson: "",
              });
            } else {
              setIsOtherUserType(false);
            }

            setAppointmentWithName(appoinmentWithValue);
            localStorage.setItem("appoinmentWithValue", appoinmentWithValue);

            if (appoinmentWithValue == customer.toLowerCase()) {

              setInputDisbledOthers(false);
              request(
                BASEURL,
                isUser.toLowerCase() == "manager"
                  ? getCustomerByMaster
                  : isUser.toLowerCase() == "employee"
                  ? getCustomerByUser
                  : isUser.toLowerCase() == "superuser"
                  ? allCustomer
                  : "Data Not Found",
                { id: currentUser?.id }
              ).then((res) => {
                setWithData(
                  isUser.toLowerCase() == "manager"
                    ? res.getCustomerdetailByMaster
                    : isUser.toLowerCase() == "employee"
                    ? res.getCustomerdetailByUser
                    : isUser.toLowerCase() == "superuser"
                    ? res.allCustomer
                    : []
                );
              });
              setAppotimentSelctStatus(true);
              setContactDisbledPersonStatus(true);
              setAppointmentData((prevData) => ({
                ...prevData,

                withName: "",
                withNameStatus: "unchecked",
              }));
            } else if (appoinmentWithValue == vendor.toLowerCase()) {
              setInputDisbledOthers(false);
              request(
                BASEURL,
                isUser.toLowerCase() == "manager"
                  ? getVendorByMaster
                  : isUser.toLowerCase() == "employee"
                  ? getVendorByUser
                  : isUser.toLowerCase() == "superuser"
                  ? allVendor
                  : "Data Not Found",
                { id: currentUser?.id }
              ).then((res) => {
                setWithData(
                  isUser.toLowerCase() == "manager"
                    ? res.getVendordetailByMaster
                    : isUser.toLowerCase() == "employee"
                    ? res.getVendordetailByUser
                    : isUser.toLowerCase() == "superuser"
                    ? res.allVendor
                    : []
                );
              });
              setContactDisbledPersonStatus(true);
              setAppotimentSelctStatus(true);
              setAppointmentData((prevData) => ({
                ...prevData,

                withName: "",
                withNameStatus: "unchecked",
              }));
              // setWithData(vendorData);
            } else if (appoinmentWithValue == leadName.toLowerCase()) {
              setInputDisbledOthers(false);

              request(
                BASEURL,
                isUser.toLowerCase() == "manager"
                  ? getLeadProspectByMaster
                  : isUser.toLowerCase() == "employee"
                  ? getLeadProspectByUser
                  : isUser.toLowerCase() == "superuser"
                  ? allLeadprospect
                  : "Data Not Found",
                { id: currentUser?.id }
              ).then((res) => {
                setWithData(
                  isUser.toLowerCase() == "manager"
                    ? res.getLeadprospectDetailByMaster
                    : isUser.toLowerCase() == "employee"
                    ? res.getLeadprospectDetailByUser
                    : isUser.toLowerCase() == "superuser"
                    ? res.allLeadprospect
                    : []
                );
              });
              setContactDisbledPersonStatus(true);
              setAppotimentSelctStatus(true);
              setAppointmentData((prevData) => ({
                ...prevData,

                withName: "",

                withNameStatus: "unchecked",
              }));

              // setWithData(leadData);
            } else if (appoinmentWithValue == "others") {
              setInputDisbledOthers(true);
              setContactDisbledPersonStatus(false);
              setAppotimentSelctStatus(true);
            } else {
              setAppotimentSelctStatus(true);
              setInputDisbledOthers(true);
              setContactDisbledPersonStatus(false);
            }

            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              appointmentState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              if (event?.label == "Others") {
                appointmentState["withName"] = "";
                appointmentState["withNameStatus"] = "unchecked";

                appointmentState["email"] = "";
                appointmentState["name"] = "";
                appointmentState["phoneNumber"] = "";
                appointmentState["emailStatus"] = "unchecked";
                appointmentState["nameStatus"] = "unchecked";
                appointmentState["phoneNumberStatus"] = "unchecked";
                appointmentState["contactPerson"] = "";
                appointmentState["contactPersonStatus"] = "unchecked";
              } else {
                appointmentState["withName"] = "";
                appointmentState["withNameStatus"] = "unchecked";
                appointmentState["email"] = "";
                appointmentState["name"] = "";
                appointmentState["phoneNumber"] = "";
                appointmentState["emailStatus"] = "unchecked";
                appointmentState["nameStatus"] = "unchecked";
                appointmentState["phoneNumberStatus"] = "unchecked";
                appointmentState["contactPerson"] = "";
                appointmentState["contactPersonStatus"] = "unchecked";
              }
            } else {
              appointmentState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              appointmentState["withName"] = "";
              appointmentState["withNameStatus"] = "unchecked";
              appointmentState["email"] = "";
              appointmentState["name"] = "";
              appointmentState["phoneNumber"] = "";
              appointmentState["emailStatus"] = "unchecked";
              appointmentState["nameStatus"] = "unchecked";
              appointmentState["phoneNumberStatus"] = "unchecked";
            }
          }
          break;
        case "withName":
          {
            const orgId = event?.value;

            request(
              BASEURL,
              isUser.toLowerCase() == "manager"
                ? getContactdetailByMaster
                : isUser.toLowerCase() == "employee"
                ? getContactdetailByUser
                : isUser.toLowerCase() == "superuser"
                ? allContact
                : "Data Not Found",
              { id: currentUser?.id }
            ).then((res) => {
              const response =
                isUser.toLowerCase() == "manager"
                  ? res.getContactdetailByMaster
                  : isUser.toLowerCase() == "employee"
                  ? res.getContactdetailByUser
                  : isUser.toLowerCase() == "superuser"
                  ? res.allContact
                  : [];

              const cus = response.filter((val, ind) => {
                if (
                  val.organizationName?.toLowerCase() ==
                  event?.label?.toLowerCase()
                ) {
                  return val;
                } else {
                  appointmentState["email"] = "";
                  appointmentState["name"] = "";
                  appointmentState["phoneNumber"] = "";
                  appointmentState["emailStatus"] = "unchecked";
                  appointmentState["nameStatus"] = "unchecked";
                  appointmentState["phoneNumberStatus"] = "unchecked";
                  appointmentState["contactPerson"] = "";
                  appointmentState["contactPersonStatus"] = "unchecked";
                }
              });
              setSelectCustomerOption(cus);
            });
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              appointmentState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
              appointmentState["email"] = "";
              appointmentState["name"] = "";
              appointmentState["phoneNumber"] = "";
              appointmentState["emailStatus"] = "unchecked";
              appointmentState["nameStatus"] = "unchecked";
              appointmentState["phoneNumberStatus"] = "unchecked";
              appointmentState["contactPerson"] = "";
              appointmentState["contactPersonStatus"] = "unchecked";
            } else {
              appointmentState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
              appointmentState["email"] = "";
              appointmentState["name"] = "";
              appointmentState["phoneNumber"] = "";
              appointmentState["emailStatus"] = "unchecked";
              appointmentState["nameStatus"] = "unchecked";
              appointmentState["phoneNumberStatus"] = "unchecked";
              appointmentState["contactPerson"] = "";
              appointmentState["contactPersonStatus"] = "unchecked";
            }
          }
          break;
        case "contactPerson": {

          selectCustomerOption.filter((val) => {
            if (val.id == event?.value) {
              appointmentState["email"] = val.mailId;
              appointmentState["emailStatus"] = "success";
              appointmentState["name"] = val.firstName;
              appointmentState["phoneNumber"] = val.contactNumber;
              appointmentState["nameStatus"] = "success";
              appointmentState["phoneNumberStatus"] = "success";
            }
          });
          const lengthRegex = new RegExp("^[A-Za-z0-9]");
          if (lengthRegex.test(event?.label) === true) {
            appointmentState[selectEvent.name + "Status"] =
              event?.label === undefined ? "unchecked" : "success";
          } else {
            appointmentState[selectEvent.name + "Status"] =
              selectEvent.value === "" ? "unchecked" : "error";
            appointmentState["email"] = "";
            appointmentState["emailStatus"] = "unchecked";
            appointmentState["name"] = "";
            appointmentState["phoneNumber"] = "";
            appointmentState["nameStatus"] = "unchecked";
            appointmentState["phoneNumberStatus"] = "unchecked";
          }
        }
      }

      appointmentState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "visiteddate": {
          const today = new Date().toISOString().split("T")[0];
          if (event?.target.value) {
            // const selectedDate = new Date(event.target.value);
            // const today = new Date();
            // today.setHours(0, 0, 0, 0);
            // const oneWeekAgo = new Date(today);
            // oneWeekAgo.setDate(today.getDate() - 7);

            appointmentState[event.target.name + "Status"] = "success";

            appointmentState[event.target.name] = event.target.value;
          } else {
            appointmentState[event?.target.name] = today;
            // appointmentState[event.target.name + "Status"] = "unchecked";
          }
          break;
        }
        case "organizationName": {
          // Regex: Ensures no numbers and allows alphabetic characters, spaces, and special characters
          const validationRegex = new RegExp(
            "^[A-Za-z!@#$%^&*()_+={}|:;,.?<>~`\\-\\[\\]\\/\\\"\\'\\s]{2,30}$" // Allows letters, special characters, and spaces
          );

          const trimmedValue = event.target.value?.trim();
          let errorMessage = "";

          // Only validate if there's input
          if (trimmedValue !== "") {
            // Check if input contains any numbers (using a regex for numbers)
            const containsNumbers = /\d/.test(trimmedValue); // Regex to check for digits

            if (containsNumbers) {
              appointmentState[event.target.name + "Status"] = "error";
              errorMessage = "Organization Name should not contain numbers.";
            } else if (!validationRegex.test(trimmedValue)) {
              // If it passes the number check but fails the other character constraints
              appointmentState[event.target.name + "Status"] = "error";
              errorMessage = "Organization Name should be  30 characters long";
            } else {
              appointmentState[event.target.name + "Status"] = "success";
              errorMessage = ""; // Clear error message if validation passes
            }
          } else {
            // If input is empty
            appointmentState[event.target.name + "Status"] = "unchecked"; // Status set to 'unchecked'
            errorMessage = ""; // No error message for empty input
          }

          // Optionally update the state with the error message
          appointmentState[event.target.name + "ErrorMessage"] = errorMessage;
          break;
        }
        case "contactPerson": {
          // Regex: Ensures no numbers and allows alphabetic characters, spaces, and special characters
          const validationRegex = new RegExp(
            "^[A-Za-z!@#$%^&*()_+={}|:;,.?<>~`\\-\\[\\]\\/\\\"\\'\\s]{2,30}$" // Allows letters, special characters, and spaces
          );

          const trimmedValue = event.target.value?.trim();
          let errorMessage = "";

          // Only validate if there's input
          if (trimmedValue !== "") {
            // Check if input contains any numbers (using a regex for numbers)
            const containsNumbers = /\d/.test(trimmedValue); // Regex to check for digits

            if (containsNumbers) {
              appointmentState[event.target.name + "Status"] = "error";
              errorMessage = "Contact Person should not contain numbers.";
            } else if (!validationRegex.test(trimmedValue)) {
              // If it passes the number check but fails the other character constraints
              appointmentState[event.target.name + "Status"] = "error";
              errorMessage = "Contact Person should be  30 characters long";
            } else {
              appointmentState[event.target.name + "Status"] = "success";
              errorMessage = ""; // Clear error message if validation passes
            }
          } else {
            // If input is empty
            appointmentState[event.target.name + "Status"] = "unchecked"; // Status set to 'unchecked'
            errorMessage = ""; // No error message for empty input
          }

          // Optionally update the state with the error message
          appointmentState[event.target.name + "ErrorMessage"] = errorMessage;
          break;
        }
        case "time":
          {
            const alphaNLenghthRegex = new RegExp("^.{2,500}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              appointmentState[event.target.name + "Status"] = "success";
            } else {
              appointmentState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{2,25})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              appointmentState[event.target.name + "Status"] = "success";
            } else {
              appointmentState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "email": {
          const strictEmailRegex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu|in)$/;

          if (strictEmailRegex.test(event.target.value?.trim())) {
            appointmentState[event.target.name + "Status"] = "success";
          } else {
            appointmentState[event.target.name + "Status"] =
              event.target.value === "" ? "unchecked" : "error";
          }
          break;
        }

        case "phoneNumber":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{10})$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              appointmentState[event.target.name + "Status"] = "success";
            } else {
              appointmentState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        // case "organizationName": {
        //   // Regex: Ensures no numbers and allows alphabetic characters, spaces, and special characters
        //   const validationRegex = new RegExp(
        //     "^[A-Za-z!@#$%^&*()_+={}|:;,.?<>~`\\-\\[\\]\\/\\\"\\'\\s]{2,30}$" // Allows letters, special characters, and spaces
        //   );

        //   const trimmedValue = event.target.value?.trim();
        //   let errorMessage = "";

        //   // Only validate if there's input
        //   if (trimmedValue !== "") {
        //     // Check if input contains any numbers (using a regex for numbers)
        //     const containsNumbers = /\d/.test(trimmedValue); // Regex to check for digits

        //     if (containsNumbers) {
        //       appointmentState[event.target.name + "Status"] = "error";
        //       errorMessage = "Organization Name should not contain numbers.";
        //     } else if (!validationRegex.test(trimmedValue)) {
        //       // If it passes the number check but fails the other character constraints
        //       appointmentState[event.target.name + "Status"] = "error";
        //       errorMessage = "Organization Name should be and 30 characters long";
        //     } else {
        //       appointmentState[event.target.name + "Status"] = "success";
        //       errorMessage = ""; // Clear error message if validation passes
        //     }
        //   } else {
        //     // If input is empty
        //     appointmentState[event.target.name + "Status"] = "unchecked"; // Status set to 'unchecked'
        //     errorMessage = ""; // No error message for empty input
        //   }

        //   // Optionally update the state with the error message
        //   appointmentState[event.target.name + "ErrorMessage"] = errorMessage;
        //   break;
        // }

        case "description":
          {
            const alphaNLenghthRegex = new RegExp("^[\\s\\S]{2,500}$");
            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              appointmentState[event.target.name + "Status"] = "success";
            } else {
              appointmentState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
      }

      if (changeAllowed && event.target.name !== "visiteddate") {
        appointmentState[event.target.name] = event.target.value;
      }
    }
    if (event?.target?.name == "visitedwith" && event?.value == "Others") {
      setInputData(appointmentState);
    } else {
      setAppointmentData(appointmentState);
    }
  };

  const handlemulipleSelect = (event, newValue) => {
    setSelctedEmploye(newValue);
  };
  const otherHandel = (event) => {
    const appointmentState = { ...inputData };
    if (event) {
      if (event?.target?.name == "organizationName") {
        const validationRegex = new RegExp(
          "^[A-Za-z!@#$%^&*()_+={}|:;,.?<>~`\\-\\[\\]\\/\\\"\\'\\s]{2,30}$" // Allows letters, special characters, and spaces
        );

        const trimmedValue = event.target.value?.trim();
        let errorMessage = "";
        if (trimmedValue !== "") {
          const containsNumbers = /\d/.test(trimmedValue);
          if (containsNumbers) {
            appointmentState[event.target.name + "Status"] = "error";
            errorMessage = "Organization Name should not contain numbers.";
          } else if (!validationRegex.test(trimmedValue)) {
            // If it passes the number check but fails the other character constraints
            appointmentState[event.target.name + "Status"] = "error";
            errorMessage = "Organization Name should be  30 characters long";
          } else {
            appointmentState[event.target.name + "Status"] = "success";
            errorMessage = ""; // Clear error message if validation passes
          }
        } else {
          // If input is empty
          appointmentState[event.target.name + "Status"] = "unchecked"; // Status set to 'unchecked'
          errorMessage = ""; // No error message for empty input
        }

        // Optionally update the state with the error message
        appointmentState[event.target.name + "ErrorMessage"] = errorMessage;
      } else {
        const validationRegex = new RegExp(
          "^[A-Za-z!@#$%^&*()_+={}|:;,.?<>~`\\-\\[\\]\\/\\\"\\'\\s]{2,30}$" // Allows letters, special characters, and spaces
        );

        const trimmedValue = event.target.value?.trim();
        let errorMessage = "";

        // Only validate if there's input
        if (trimmedValue !== "") {
          // Check if input contains any numbers (using a regex for numbers)
          const containsNumbers = /\d/.test(trimmedValue); // Regex to check for digits

          if (containsNumbers) {
            appointmentState[event.target.name + "Status"] = "error";
            errorMessage = "Contact Person should not contain numbers.";
          } else if (!validationRegex.test(trimmedValue)) {
            // If it passes the number check but fails the other character constraints
            appointmentState[event.target.name + "Status"] = "error";
            errorMessage = "Contact Person should be  30 characters long";
          } else {
            appointmentState[event.target.name + "Status"] = "success";
            errorMessage = ""; // Clear error message if validation passes
          }
        } else {
          // If input is empty
          appointmentState[event.target.name + "Status"] = "unchecked"; // Status set to 'unchecked'
          errorMessage = ""; // No error message for empty input
        }

        // Optionally update the state with the error message
        appointmentState[event.target.name + "ErrorMessage"] = errorMessage;
      }

      appointmentState[event.target.name] = event.target.value;
      setInputData(appointmentState);
    }
  };

  //Handle Change for Task Title
  const handleTaskTitle = (event, selectEvent) => {
    let taskStatusState = { ...taskData };
    if(event?.target === undefined && selectEvent){
      switch(selectEvent.name){
        case "taskTitle": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{1,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            taskStatusState[selectEvent.name + "Status"] = "success";
          } else {
            taskStatusState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          break;
        }
      }
      taskStatusState[selectEvent.name] = event;
    }
    setTaskData(taskStatusState);
  }; 
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
          done={confirmationDialog.done}
          back={confirmationDialog.back}
        />
      )}

      <Card>
        <CardHeader
          title={
            <>
              {togglePage.view === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Visit Log details
                    </MaterialTypography>
                  </Stack>
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                  </ButtonGroup>
                </Stack>
              ) : togglePage.edit === true ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Edit Visit Log
                    </MaterialTypography>
                  </Stack>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                >
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h6" fontWeight="medium">
                      Add Visit Log
                    </MaterialTypography>
                  </Stack>
                </Stack>
              )}
            </>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
         <Stack direction="row" spacing={1} p={1} bgcolor={"#f5f5f5"}>
                                 <BsFillPersonBadgeFill style={{ fontSize: 20, color:'#460058' }} />
                                 <MaterialTypography
                                 sx={{color:'#460058',fontFamily:'Aptos'}}
                                   component="label"
                                   variant="body2"
                                   fontWeight="700"
                                 >
                                   Visit Information
                                 </MaterialTypography>
                               </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Visited Date<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="visiteddate"
                  type="date"
                  placeholder="Visited Date"
                  value={appointmentData.visiteddate}
                  onChange={handleAppointmentData}
                  // inputProps={{
                  //   min: formattedOneWeekAgo,
                  //   max: formattedToday,
                  // }}
                  inputProps={{
                    min: new Date(new Date().setDate(new Date().getDate() - 7)) // 7 days before today
                      .toISOString()
                      .split("T")[0],
                    max: new Date() // Today's date
                      .toISOString()
                      .split("T")[0],
                  }}
                  error={
                    appointmentData.visiteddateStatus === "error" ? true : false
                  }
                  success={
                    appointmentData.visiteddateStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true}
                />
                {appointmentData.visiteddateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Visited date should only be a past One week date or the
                      current date
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Visited Time<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="time"
                  type="time"
                  placeholder="eg. 01-01-2024"
                  value={appointmentData.time}
                  onChange={handleAppointmentData}
                  error={appointmentData.timeStatus === "error" ? true : false}
                  success={
                    appointmentData.timeStatus === "success" ? true : false
                  }
                  disabled={togglePage?.view === true}
                />
                {appointmentData.timeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Please Enter a Valid Time</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Visit With <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="visitedwith"
                  value={appointmentData.visitedwith}
                  // defaultValue={{ label: "Mr." }}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleAppointmentData} //selectedValue, event
                  options={VisitWithDataOptions.map((value) => {
                    return {
                      value: value.value,
                      label: value.lable,
                    };
                  })}
                  error={
                    appointmentData.visitedwithStatus === "error" ? true : false
                  }
                  success={
                    appointmentData.visitedwithStatus === "success"
                      ? true
                      : false
                  }
                  isDisabled={togglePage?.view === true ? true : false}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Task Title<span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialSelect
                      name="taskTitle"
                      options={titleOptions}
                      value={taskData.taskTitle}
                      onChange={handleTaskTitle}
                      error={taskData.taskTitleStatus === "error"}
                      success={taskData.taskTitleStatus === "success"}
                      isDisabled={togglePage?.view === true ? true : false}
                    />
                 
                </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Organization Name
                    {!inputDisbledOthers && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </MaterialTypography>
                </MaterialBox>
                {isOtherUserType ? (
                  <>
                    <MaterialInput
                      name="organizationName"
                      placeholder=" Organization Name..."
                      value={inputData.organizationName}
                      onChange={otherHandel}
                      error={inputData.organizationNameStatus === "error"}
                      success={inputData.organizationNameStatus === "success"}
                      disabled={togglePage?.view === true ? true : false}
                    />
                    {inputData.organizationNameStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          {inputData.organizationNameErrorMessage}
                        </FormHelperText>
                      </FormControl>
                    )}
                  </>
                ) : (
                  <MaterialSelect
                    name="withName"
                    value={appointmentData.withName}
                    // defaultValue={{ label: "Mr." }}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleAppointmentData} //selectedValue, event
                    options={withData.map((value) => {
                      return {
                        value: value.id,
                        label:
                          appointmentWithName == leadName.toLowerCase()
                            ? value.companyName
                            : value.legalName,
                      };
                    })}
                    error={
                      appointmentData.withNameStatus === "error" ? true : false
                    }
                    success={
                      appointmentData.withNameStatus === "success"
                        ? true
                        : false
                    }
                    isDisabled={inputDisbledOthers}
                  />
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Person{" "}
                    {!inputDisbledOthers && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </MaterialTypography>
                </MaterialBox>
                {isOtherUserType ? (
                  <>
                    <MaterialInput
                      name="contactPerson"
                      placeholder=" Contact Person..."
                      value={inputData.contactPerson}
                      onChange={otherHandel}
                      error={inputData.contactPersonStatus === "error"}
                      success={inputData.contactPersonStatus === "success"}
                      disabled={togglePage?.view === true ? true : false}
                    />
                    {inputData.contactPersonStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          {inputData.contactPersonErrorMessage}
                        </FormHelperText>
                      </FormControl>
                    )}
                  </>
                ) : (
                  <MaterialSelect
                    name="contactPerson"
                    value={appointmentData.contactPerson}
                    // defaultValue={{ label: "Mr." }}
                    customStyles={{ optionPadding: 20 }}
                    onChange={handleAppointmentData} //selectedValue, event
                    options={selectCustomerOption.map((value) => {
                      return {
                        value: value.id,
                        label: value.firstName,
                      };
                    })}
                    error={
                      appointmentData.contactPersonStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      appointmentData.contactPersonStatus === "success"
                        ? true
                        : false
                    }
                    isDisabled={!contactPersonDisbledStatus}
                  />
                )}
              </Grid>
              {/* <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Name<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="name"
                  placeholder="Enter Your Name"
                  value={appointmentData.name}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleAppointmentData}
                  error={appointmentData.nameStatus === "error" ? true : false}
                  success={
                    appointmentData.nameStatus === "success" ? true : false
                  }
                  disabled={appointmentData?.visitedwith.label != "Others" ? true : false}
                />
                {appointmentData.nameStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Name should be Maximum 25 characters
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid> */}
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Email<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="email"
                  placeholder="Enter your email"
                  value={appointmentData.email}
                  onChange={handleAppointmentData}
                  error={appointmentData.emailStatus === "error" ? true : false}
                  success={
                    appointmentData.emailStatus === "success" ? true : false
                  }
                  disabled={
                    appointmentData?.visitedwith.label != "Others"
                      ? true
                      : false
                  }
                />
                {appointmentData.emailStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Enter Valid Email Address</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="phoneNumber"
                  placeholder="Enter your phonenumber"
                  value={appointmentData.phoneNumber}
                  onChange={handleAppointmentData}
                  error={
                    appointmentData.phoneNumberStatus === "error" ? true : false
                  }
                  success={
                    appointmentData.phoneNumberStatus === "success"
                      ? true
                      : false
                  }
                  disabled={
                    appointmentData?.visitedwith.label != "Others"
                      ? true
                      : false
                  }
                />
                {appointmentData.phoneNumberStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Enter a Valid PhoneNumber</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Description <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="description"
                  multiline
                  rows={3}
                  placeholder="Write Description..."
                  value={appointmentData.description}
                  onChange={handleAppointmentData}
                  error={
                    appointmentData.descriptionStatus === "error" ? true : false
                  }
                  success={
                    appointmentData.descriptionStatus === "success"
                      ? true
                      : false
                  }
                  disabled={togglePage?.view === true}
                />
                {appointmentData.descriptionStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Description Should be maximum 50 characters long
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
            <div style={{ marginTop: "25px" }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Visited By <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <Autocomplete
                multiple
                id="tags-outlined"
                options={employeeData}
                getOptionLabel={(option) => `${option.username}`} // Custom display format
                value={selectedEmployee}
                onChange={handlemulipleSelect}
                filterSelectedOptions
                renderTags={(selected, getTagProps) =>
                  selected.map((option, index) => (
                    <Chip
                      key={option.id}
                      label={`${option.username}`} // Customize tag display
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select... " />
                )}
                disabled={togglePage?.view === true}
              />
            </div>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            {togglePage.edit === true ? (
              <>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  onClick={handleDiscardButton}
                >
                  Discard
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleupdateVisit}
                >
                  Update
                </MaterialButton>
              </>
            ) : togglePage.view === false && togglePage.edit === false ? (
              <>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  disabled={!checkAllFields()}
                  onClick={handleAddVisit}
                >
                  Submit
                </MaterialButton>
                <MaterialButton
                  sx={{ m: 2 }}
                  variant="gradient"
                  color="dark"
                  onClick={handleCancelVisitData}
                >
                  Cancel
                </MaterialButton>
              </>
            ) : null}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default AppointmentForm;
